import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("Zenith Ranking_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const setStoredToken = (t) => {
  if (t) localStorage.setItem("Zenith Ranking_token", t);
  else localStorage.removeItem("Zenith Ranking_token");
};
